import merge from 'lodash.merge';

import results from '~/pages/Results/resolvers';
import clientDefaults from '~/cache/resolvers';

export default merge(results, clientDefaults);
